import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FaInfoCircle, FaFootballBall, FaGraduationCap, FaHome, FaUtensils, FaBus } from 'react-icons/fa';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import bgImage from '../../assets/img/pictures/tttt.jpg';

const Fees = () => {
  const [activeTab, setActiveTab] = useState('new-registration');

  const feeCategories = [
    {
      id: 'new-registration',
      title: 'Football With Academic Education in Kempshot - New Registration',
      fees: [
        { name: 'Football Academy Registration Fees (Biennial)', foundation: '₵3,050.00', youth: '₵3,450.00', pro: '₵4,250.00' },
        { name: 'Admission Fees (One-time payment)', foundation: '₵715.00', youth: '₵715.00', pro: '₵715.00' },
        { name: 'Academic School Fees per term (Scholarship for selected players)', foundation: '₵975.00', youth: '₵1,145.00', pro: '₵1,865.00' },
        { name: 'Boarding Fee per term', foundation: '₵3,000.00', youth: '₵3,000.00', pro: '₵3,000.00' },
        { name: 'Football Education, Training & Coaching', foundation: 'Free', youth: 'Free', pro: 'Free' },
        { name: 'Feeding and Bus Fees', foundation: 'Payable', youth: 'Payable', pro: 'Payable' },
        { name: 'Non-Residence Foreign Student (Biennial)', foundation: '₵18,633.00', youth: '₵20,571.00', pro: '₵25,860.00' }
      ]
    },
    {
      id: 'football-only',
      title: 'Football Related Education Only - New Entrants',
      fees: [
        { name: 'Football Academy Registration Fee - Ghanaian (Biennial)', foundation: '₵3,050.00', youth: '₵3,450.00', pro: '₵4,250.00' },
        { name: 'Football Academy Registration Fee - Foreign Residence (Biennial)', foundation: '₵4,302.00', youth: '₵6,284.00', pro: '₵9,120.00' },
        { name: 'Training, Coaching, Football Education', foundation: 'Free', youth: 'Free', pro: 'Free' }
      ]
    },
    {
      id: 'existing-registration',
      title: 'Football with Education in Kempshot - Existing Registration (2024)',
      fees: [
        { name: 'Academy School Fees per term + Admission Fees', foundation: '₵1,690.00', youth: '₵1,860.00', pro: '₵2,580.00' },
        { name: 'Boarding Fees per term', foundation: '₵3,000.00', youth: '₵3,000.00', pro: '₵3,000.00' },
        { name: 'Football Academy Biennial Registration Fee (+ Arrears)', foundation: '₵650.00', youth: '₵750.00', pro: '₵950.00' }
      ]
    }
  ];

  const requiredKits = [
    { name: 'Official Training Jersey with hose', quantity: '2 Pcs' },
    { name: 'Baseball Cap', quantity: '1 Pc' },
    { name: 'Track Suit', quantity: '1 Pc' },
    { name: 'Football Bag (Big Size)', quantity: '1 Pc' },
    { name: 'Raincoat', quantity: '1 Pc' },
    { name: 'Jersey T-Shirt', quantity: '1 Pc' },
    { name: 'Shin guard', quantity: '1 Pc' },
    { name: 'Hose', quantity: '2 Sets' }
  ];

  return (
    <div className="min-h-screen relative">
      {/* Background Pattern */}
      <div className="fixed inset-0 z-0">
        <img
          src={bgImage}
          alt="Background"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-blue-900/95 via-blue-900/90 to-black/95"></div>
      </div>

      <div className="relative z-10">
        <Header />

        {/* Hero Section */}
        <section className="relative py-20 overflow-hidden">
          <div className="container mx-auto px-4">
            <div className="flex flex-col lg:flex-row items-center gap-12">
              <motion.div 
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8 }}
                className="lg:w-1/2"
              >
                <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">Academy Fees</h1>
                <p className="text-xl text-blue-100 mb-8">
                  Transparent and structured fee system for all academy programs
                </p>
                <div className="flex flex-wrap gap-4">
                  <div className="flex items-center gap-2 text-blue-100">
                    <FaFootballBall className="text-blue-400" />
                    <span>Foundation (9-11 years)</span>
                  </div>
                  <div className="flex items-center gap-2 text-blue-100">
                    <FaGraduationCap className="text-blue-400" />
                    <span>Youth Development (U12-U15)</span>
                  </div>
                  <div className="flex items-center gap-2 text-blue-100">
                    <FaHome className="text-blue-400" />
                    <span>Professional Development (U17)</span>
                  </div>
                </div>
              </motion.div>
              
              <motion.div 
                initial={{ opacity: 0, x: 20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8 }}
                className="lg:w-1/2"
              >
                <div className="relative">
                  <motion.img
                    src={require("../../assets/img/pictures/WhatsApp Image 2025-03-02 at 21.24.03_3d051f18.jpg")}
                    alt="Academy Fees"
                    className="rounded-2xl shadow-2xl w-full h-[400px] object-cover"
                    whileHover={{ scale: 1.02 }}
                    transition={{ duration: 0.3 }}
                  />
                  <motion.div 
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.5 }}
                    className="absolute -bottom-6 -right-6 bg-blue-600 text-white p-4 rounded-lg shadow-lg"
                  >
                    <p className="text-sm font-semibold">Biennial Registration</p>
                    <p className="text-xs opacity-80">Every Two Years</p>
                  </motion.div>
                </div>
              </motion.div>
            </div>
          </div>
        </section>

        {/* Fee Categories */}
        <section className="py-12">
          <div className="container mx-auto px-4">
            <div className="flex flex-wrap gap-4 mb-8">
              {feeCategories.map((category) => (
                <motion.button
                  key={category.id}
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  onClick={() => setActiveTab(category.id)}
                  className={`px-6 py-3 rounded-lg font-semibold transition-colors duration-200 ${
                    activeTab === category.id
                      ? 'bg-blue-600 text-white'
                      : 'bg-white/10 text-blue-100 hover:bg-white/20'
                  }`}
                >
                  {category.title.split(' - ')[0]}
                </motion.button>
              ))}
            </div>

            {/* Fee Tables */}
            <div className="space-y-12">
              {feeCategories.map((category) => (
                <motion.div
                  key={category.id}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: activeTab === category.id ? 1 : 0, y: activeTab === category.id ? 0 : 20 }}
                  transition={{ duration: 0.3 }}
                  className={`bg-white/10 backdrop-blur-sm rounded-xl p-8 ${
                    activeTab === category.id ? 'block' : 'hidden'
                  }`}
                >
                  <h2 className="text-2xl font-bold text-white mb-6">{category.title}</h2>
                  <div className="overflow-x-auto">
                    <table className="min-w-full text-blue-100">
                      <thead>
                        <tr className="border-b border-white/20">
                          <th className="px-4 py-3 text-left">Details</th>
                          <th className="px-4 py-3 text-right">Foundation</th>
                          <th className="px-4 py-3 text-right">Youth Dev.</th>
                          <th className="px-4 py-3 text-right">Professional</th>
                        </tr>
                      </thead>
                      <tbody>
                        {category.fees.map((fee, index) => (
                          <tr key={index} className="border-b border-white/10">
                            <td className="px-4 py-3">{fee.name}</td>
                            <td className="px-4 py-3 text-right">{fee.foundation}</td>
                            <td className="px-4 py-3 text-right">{fee.youth}</td>
                            <td className="px-4 py-3 text-right">{fee.pro}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* Required Kits Section */}
        <section className="py-12 bg-white/5">
          <div className="container mx-auto px-4">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              className="max-w-4xl mx-auto"
            >
              <h2 className="text-3xl font-bold text-white mb-8">Required Academy Kits</h2>
              <div className="grid md:grid-cols-2 gap-6">
                {requiredKits.map((kit, index) => (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, x: -20 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.5, delay: index * 0.1 }}
                    className="bg-white/10 backdrop-blur-sm rounded-lg p-4"
                  >
                    <div className="flex justify-between items-center">
                      <span className="text-blue-100">{kit.name}</span>
                      <span className="text-blue-400 font-medium">{kit.quantity}</span>
                    </div>
                  </motion.div>
                ))}
              </div>
              <div className="mt-8 bg-white/10 backdrop-blur-sm rounded-lg p-6">
                <p className="text-blue-100">
                  <FaInfoCircle className="inline-block mr-2 text-blue-400" />
                  Note: Two (2) sets of Training jersey with hose shall be provided by the academy after the initial deposit payment. Remaining kits to be purchased by the players themselves.
                </p>
              </div>
            </motion.div>
          </div>
        </section>

        {/* Additional Information */}
        <section className="py-12">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto space-y-8">
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                className="bg-white/10 backdrop-blur-sm rounded-xl p-8"
              >
                <h2 className="text-2xl font-bold text-white mb-6">Important Notes</h2>
                <ul className="space-y-4 text-blue-100">
                  <li className="flex items-start gap-3">
                    <FaInfoCircle className="text-blue-400 mt-1 flex-shrink-0" />
                    <span>Players shall pay school fees according to their department</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <FaInfoCircle className="text-blue-400 mt-1 flex-shrink-0" />
                    <span>Failed final assessment: Registration fees (minus form and admin charges) will be refunded</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <FaInfoCircle className="text-blue-400 mt-1 flex-shrink-0" />
                    <span>Waiting list candidates: Admitted as regular students until next registration season</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <FaInfoCircle className="text-blue-400 mt-1 flex-shrink-0" />
                    <span>Process completion: Within one week from form submission and full payment</span>
                  </li>
                </ul>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                className="bg-white/10 backdrop-blur-sm rounded-xl p-8"
              >
                <h2 className="text-2xl font-bold text-white mb-6">Cost Coverage</h2>
                <div className="grid md:grid-cols-2 gap-8">
                  <div>
                    <h3 className="text-xl font-semibold text-white mb-4">Covered by Academy</h3>
                    <ul className="space-y-2 text-blue-100">
                      <li>Training and Coaching</li>
                      <li>Football Tuition</li>
                      <li>Facility & Equipment</li>
                      <li>Sports Science</li>
                      <li>Development Programs</li>
                    </ul>
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-white mb-4">Additional Costs (When Needed)</h3>
                    <ul className="space-y-2 text-blue-100">
                      <li>Match Expenses</li>
                      <li>Travel & Accommodation</li>
                      <li>Medical & Insurance</li>
                      <li>Tournament & Event Fees</li>
                      <li>Video Analysis</li>
                      <li>Marketing & Promotion</li>
                      <li>Camping Fees</li>
                      <li>Outside Trials</li>
                    </ul>
                  </div>
                </div>
              </motion.div>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </div>
  );
};

export default Fees; 